const ANSWER = {
  yes: 'yes',
  no: 'no'
};

const DEFAULT_API_BASE_URL = 'https://api.smartgift-dev.net';
const DEFAULT_APP_BASE_URL = '/';
const DEFAULT_CDN_PATH = 'https://cdn.heroengage.com';
const DEFAULT_HAS_INTERNAL_ASSETS = ANSWER.yes;
const DEFAULT_MERCHANT_NAME = '1800flowers';
const DEFAULT_PUBLIC_URL = '';

const DEFAULT_ENV = {
  development: 'development',
  production: 'production',
  local: 'local',
  test: 'test'
};

export {
  ANSWER,
  DEFAULT_API_BASE_URL,
  DEFAULT_APP_BASE_URL,
  DEFAULT_CDN_PATH,
  DEFAULT_ENV,
  DEFAULT_HAS_INTERNAL_ASSETS,
  DEFAULT_MERCHANT_NAME,
  DEFAULT_PUBLIC_URL
};
